import _sfc_main from "./component-library157.mjs";
import "./component-library158.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  _vm._self._setupProxy;
  return _vm.filteredList.length > 1 ? _c("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: _vm.onClickaway, expression: "onClickaway" }], staticClass: "energy-label-datasheet", attrs: { "data-testid": "dropdown" } }, [_c("LinkButton", { staticClass: "energy-label-datasheet__button", style: `--label-color: ${_vm.labelColor}`, attrs: { "tag": "button", "text": "", "type": "button" }, nativeOn: { "click": function($event) {
    $event.preventDefault();
    return _vm.onToggle();
  } } }, [_c("span", [_vm._v(_vm._s(_vm.label))]), _c("Arrow", { staticClass: "energy-label-datasheet__arrow", attrs: { "direction": _vm.isOpened ? "top" : "bottom", "tag": "span" } })], 1), _vm.isOpened ? _c("div", [_vm._t("default", function() {
    return [_c("ul", { staticClass: "energy-label-datasheet__list", class: `energy-label-datasheet__list--${_vm.alignDropdown}` }, _vm._l(_vm.filteredList, function(product, index) {
      return _c("li", { key: index, staticClass: "energy-label-datasheet__list-item" }, [_vm.isInternalLink ? _c("LinkButton", { attrs: { "tag": "button", "text": "" }, nativeOn: { "click": function($event) {
        $event.preventDefault();
        return _vm.$emit("open-document", product.documentPath);
      } } }, [_vm._v(" " + _vm._s(product.name) + " ")]) : _c("LinkButton", { attrs: { "href": product.documentPath, "tag": "a", "target": "_blank", "text": "" } }, [_vm._v(" " + _vm._s(product.name) + " ")])], 1);
    }), 0)];
  }, { "products": _vm.filteredList })], 2) : _vm._e()], 1) : _vm.singleItem ? _c("div", { staticClass: "energy-label-datasheet", attrs: { "data-testid": "single" } }, [_vm.isInternalLink ? _c("LinkButton", { staticClass: "energy-label-datasheet__button", style: `--label-color: ${_vm.labelColor}`, attrs: { "tag": "button", "text": "" }, nativeOn: { "click": function($event) {
    $event.preventDefault();
    return _vm.$emit("open-document", _vm.singleItem.documentPath);
  } } }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _c("LinkButton", { staticClass: "energy-label-datasheet__button", style: `--label-color: ${_vm.labelColor}`, attrs: { "data-url": _vm.singleItem.documentPath, "tag": "button", "text": "" }, nativeOn: { "click": function($event) {
    $event.preventDefault();
    return _vm.openNewTab(_vm.singleItem.documentPath || "");
  } } }, [_vm._v(" " + _vm._s(_vm.label) + " ")])], 1) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "b1bde761",
  null,
  null
);
const Datasheet = __component__.exports;
export {
  Datasheet as default
};
